import { render, staticRenderFns } from "./EuthanasiaStatistics.vue?vue&type=template&id=3bae918a&scoped=true&"
import script from "./EuthanasiaStatistics.vue?vue&type=script&lang=js&"
export * from "./EuthanasiaStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae918a",
  null
  
)

export default component.exports